export default defineNuxtPlugin(() => {
  const route = useRoute()

  // Manual pageview tracking for every route change.
  watch(
    () => route.fullPath,
    () => {
      useTrackPageview()
    },
    { immediate: true },
  )
})
